import styled from 'styled-components';
import {StrategyTableContainer, StrategyTableWrapper} from '../../../pages/Strategy/styles';

/**
 * Sem padding lateral extra (a listagem usa StrategyTableWrapper com 16–32px;
 * aqui o card já tem padding — alinha a tabela à largura dos cards de métricas).
 */
export const ReportTradingTableWrap = styled(StrategyTableWrapper)`
    margin-top: 0 !important;
    padding: 0 !important;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
`;

/** Tabela em largura total do bloco */
export const ReportTradingTableContainer = styled(StrategyTableContainer)`
    width: 100% !important;
    max-width: 100%;

    .MuiTable-root {
        width: 100% !important;
        min-width: 100% !important;
        table-layout: auto;
    }

    @media (max-width: 599px) {
        .MuiTable-root {
            min-width: 600px !important;
        }
    }
`;

/** Texto secundário sob a contagem de operações (mesmo tom da listagem: small #888) */
export const OpsMeta = styled.span`
    display: block;
    font-size: 11px;
    color: #888;
    margin-top: 8px;
    line-height: 1.5;
    font-variant-numeric: tabular-nums;
`;
